import React from 'react';
import { VideoPlayer,ReactVideoProvider } from 'react-video-master';

import '../player.css';

function Origin() {
    return (
        <ReactVideoProvider>
            <div style={{width:"400px"}}>
                <VideoPlayer
                    src="https://demo.clerkai.app/ai/puma.mp4"
                    onPlay={() => console.log('Video started playing')}
                    onPause={() => console.log('Video paused')}
                    onEnded={() => console.log('Video ended')}
                    paused={false}
                />
            </div>
        </ReactVideoProvider>
    );
}

export default Origin;